import {
  Context,
  createContext,
  FC,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

import UserScopes from '../config/userScopes';

import SignInContextDefaults from '../types/SignInContextDefaults';
import { firebaseApp } from '../config/firebase';

const SignInContext = createContext<SignInContextDefaults | {}>(
  {},
) as Context<SignInContextDefaults>;

const SignInProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const hasAuthToken = () => localStorage.hasOwnProperty('auth_token');
  const [isSignedIn, setIsSignedIn] = useState(hasAuthToken);
  const [isFirebaseReady, setIsFirebaseReady] = useState(false);
  const scopes: UserScopes[] = localStorage.hasOwnProperty('scopes')
    ? JSON.parse(localStorage.getItem('scopes') || '')
    : [];

  useEffect(() => {
    const unsubscribe = firebaseApp.auth().onAuthStateChanged(() => {
      setIsFirebaseReady(true);
    });
    return unsubscribe;
  }, []);

  if (!isFirebaseReady) return null;

  return (
    <SignInContext.Provider value={{ isSignedIn, setIsSignedIn, scopes }}>
      {children}
    </SignInContext.Provider>
  );
};

const useSignInContext = () => useContext(SignInContext);

export { SignInProvider, useSignInContext };
